// painel360-asof-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Até %{month}": "Hasta %{month}",
    "Base de hoje. Se o período terminar num mês já fechado (até 12 meses atrás), o card mostra como ela estava no fim daquele mês.": "Base de hoy. Si el período termina en un mes ya cerrado (hasta 12 meses atrás), la tarjeta muestra cómo estaba al final de ese mes.",
    "Como a base estava no fim do mês em que o período termina, com os prazos de inatividade de hoje.": "Cómo estaba la base al final del mes en que termina el período, con los plazos de inactividad de hoy.",
    "Não muda com o período escolhido no topo da página.": "No cambia con el período elegido en la parte superior de la página.",
    "Posição em %{date}": "Posición al %{date}",
    "Retrato de hoje": "Situación de hoy",
    "Safras e retornos até o mês em que o período termina. O mês em andamento só entra quando fechar.": "Cohortes y regresos hasta el mes en que termina el período. El mes en curso solo entra cuando cierre.",
};

export default catalogo;
